import { ChangeBorrowCheckComponent } from "../../../components/borrowSystem/ChangeAndExtendBorrowForm/ChangeBorrowCheckComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
export function ChangeBorrowCheckContainer() {
  const titleName =
    "รายละเอียดการเปลี่ยนแปลงหลักสูตรการฝึกอบรมหรือทดสอบมาตรฐานฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <ChangeBorrowCheckComponent />
      <Footer />
    </div>
  );
}
